import React from "react";
import Container from "./Container";

export default () => <Container />;
